import {connect, State} from '@modifi/redux'

import DeleteEntryConfirmDialog from '../../../plugins/onboarding/dialogs/delete-entry-confirm-dialog'
import {selectDeleteErrorMessage, selectDeleteIsPending, aReset} from '../store'

const mapStateToProps = (state: State): {deletePending: boolean; deleteErrorMessage?: string} => ({
  deletePending: selectDeleteIsPending(state),
  deleteErrorMessage: selectDeleteErrorMessage(state),
})

const mapDispatchToProps = {
  reset: aReset,
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteEntryConfirmDialog)

export const DELETE_SHAREHOLDER_DIALOG_NAME = 'onboarding/DELETE_SHAREHOLDER_CONFIRM_DIALOG'
